import { UserQuizQuestionAnswerDto, UserQuizQuestionDto } from '@/api/generated';
import Loader from '@/components/Loader.tsx';
import { useAnswerQuizQuestion } from '@/hooks/useAnswerQuizQuestion.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import ErrorsView from '@/views/errors/ErrorsView.tsx';
import QuestionSegment4 from '@/views/process/components/quizInialized/questions/QuestionSegment4.tsx';
import {
  questionForms,
  questionSegments,
} from '@/views/process/components/quizInialized/questions/QuestionSegmentConfig.util.ts';
import { AxiosError } from 'axios';
import React from 'react';

interface Props {
  currentQuestionId?: number | null;
  errors?: AxiosError | null;
  isLoading?: boolean;
  quizDetails: UserQuizQuestionDto | undefined;
  userQuizId?: string;
}

const Questions: React.FC<Props> = ({
  currentQuestionId,
  errors,
  isLoading,
  quizDetails,
  userQuizId,
}) => {
  const { user } = useUserContext();
  const userId = user?.userId;

  const { answerQuiz, isAnswering } = useAnswerQuizQuestion();
  const loading = !!isLoading || !quizDetails || isAnswering;

  if (!userId) {
    return null;
  }

  if (errors) {
    return <ErrorsView />;
  }

  const handleAnswer = async (userQuizQuestionAnswerDto: UserQuizQuestionAnswerDto) => {
    return await answerQuiz({ userId, userQuizId, userQuizQuestionAnswerDto });
  };
  const questionDefinition = quizDetails?.questionDefinition;

  if (!currentQuestionId) {
    const FinishedComponentToRender = questionSegments[13];
    if (isLoading) {
      return <Loader className="min-h-dvh" />;
    }
    return (
      <>
        <FinishedComponentToRender />
        {loading ? <Loader /> : null}
      </>
    );
  }

  const FormComponentToRender = questionForms[questionDefinition?.discriminatorType ?? 'DEFAULT'];
  const SegmentComponentToRender = questionSegments[currentQuestionId];

  if (currentQuestionId === 4) {
    return (
      <>
        <QuestionSegment4
          disabled={loading}
          onAnswerSelected={handleAnswer}
          questionDefinition={questionDefinition as never}
        />
      </>
    );
  }

  return (
    <>
      <SegmentComponentToRender
        formComponent={
          <FormComponentToRender
            disabled={loading}
            onAnswerSelected={handleAnswer}
            questionDefinition={questionDefinition as never}
          />
        }
      />
      {isLoading && !quizDetails ? <Loader /> : null}
    </>
  );
};

export default Questions;
